'use strict';

const _=require('pulsar-utils/dist-es6/_');

const DefaultFrequency=150;let

WhilePressedDirective=class WhilePressedDirective{
static get type(){
return'directive';
}

factory($parse,$interval){
return{
restrict:'A',
scope:{
pulsarWhilePressed:'=',
whilePressedFrequency:'='},

link:(scope,element,attrs)=>{


const action=scope.pulsarWhilePressed;
const frequency=Number(attrs.whilePressedFrequency?$parse(attrs.whilePressedFrequency):DefaultFrequency);

const tickAction=()=>action(scope);

let intervalPromise=null;
const endAction=()=>{
if(intervalPromise){
$interval.cancel(intervalPromise);
}
unbindEndAction();
};

const bindEndAction=()=>{
element.on('mouseup',endAction);
element.on('mouseleave',endAction);
element.on('pointerup',endAction);
};

const unbindEndAction=()=>{
element.off('mouseup',endAction);
element.off('mouseleave',endAction);
element.off('pointerup',endAction);
};

const beginAction=e=>{
preventEventBubbling(e);
tickAction();
intervalPromise=$interval(tickAction,frequency);
bindEndAction();
};

const preventEventBubbling=e=>{
e.preventDefault();
e.stopPropagation();
};

scope.$evalAsync(()=>{
element.on('mousedown',beginAction);
element.on('pointerdown',beginAction);
element.on('click',preventEventBubbling);
element.on('mousemove',preventEventBubbling);
});

scope.$on('$destroy',()=>{
endAction();
});
}};

}};


module.exports=WhilePressedDirective;
module.exports.prototype.factory.$inject=['$parse','$interval'];
//# sourceMappingURL=whilePressedDirective.js.map
